/* src/app/components/paciente/paciente-home-image/paciente-home-image.component.scss */
/*# sourceMappingURL=paciente-home-image.component.css.map */
